module.exports = __webpack_public_path__ + "img/ultraplaybg.3f4645cb.svg";